import type { ParsedFileResult } from "../types";

let nextId = 0;

export function parseFile(file: File): Promise<ParsedFileResult> {
  return new Promise((resolve, reject) => {
    const worker = new Worker(new URL("../workers/parser.worker.ts", import.meta.url), { type: "module" });
    const id = String(nextId++);
    worker.onmessage = (event: MessageEvent<{ id: string; result?: ParsedFileResult; error?: string }>) => {
      if (event.data.id !== id) return;
      worker.terminate();
      if (event.data.error) reject(new Error(event.data.error));
      else resolve(event.data.result!);
    };
    worker.onerror = (event) => {
      worker.terminate();
      reject(new Error(event.message));
    };
    worker.postMessage({ id, file });
  });
}

export function parseFiles(files: File[]) {
  return Promise.all(files.map(parseFile));
}
